module.exports = __webpack_public_path__ + "static/media/warning.6a62d83b.svg";